import React from "react";
import { motion } from "framer-motion";
const { locations } = require("data/company.json");

export default function CompanyLocations() {
  return (
    <div className="company-locations">
      <div className="locations-title container">
        <motion.h2
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ delay: .2 }}
          className="k-title-sm lg:k-title-md"
        >
          Our Spaces
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ delay: .2 }}
          className="k-text-md md:k-text-lg lg:k-text-xl"
        >
          We're designed to seamlessly operate across cultures, timezones, and languages
        </motion.p>
      </div>

      <ul className="locations-list">
        {locations.map((card, i) => (
          <motion.li
            key={`${card.title}-${i}`}
            className="location-card group"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "0px 0px -80px 0px" }}
            transition={{ duration: 0.5, ease: "easeOut", delay: i * 0.15 }}
          >
            <div className="location-image-wrapper">
              <img
                src={`/images/locations/${card.image}`}
                alt=""
                className="absolute top-0 right-0 w-screen h-full object-cover object-center pointer-events-none transition-[filter] duration-300 ease-in-out group-hover:grayscale"
                loading="lazy"
              />
            </div>


            <div className="location-card-content container relative z-10">
              <div className="location-image-mobile">
                <img
                  src={`/images/locations/${card.image}`}
                  alt=""
                  className=""
                  loading="lazy"
                />
              </div>

              <div className="location-card-content-col">
                <h3 className="k-title-xs lg:k-title-sm">{card.title}</h3>
              </div>
              <div className="location-card-content-col">
                <div className="location-card-information lg:opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out">
                  <p className="k-text-sm xl:k-text-md description">{card.description}</p>
                  <p className="k-text-sm xl:k-text-md"><b>Top song on the playlist:</b> {card.song}</p>
                  <p className="k-text-sm xl:k-text-md">{card.text}</p>
                </div>
              </div>
            </div>
          </motion.li>
        ))}
      </ul>
    </div>
  );
}
